module.exports = __webpack_public_path__ + "img/edu-institution-3.dda43c22.png";